import { useChat } from "@/contexts/ChatContext";
import { UseOrderConversationReturn } from "@/hooks/use-order-conversation";
import { getAuthUser } from "@/lib/auth-utils";
import { useEffect, useState } from "react";
import ChatFloatingWidget from "../chat/ChatFloatingWidget";
import FacebookMessagerButton from "../chat/FacebookMessagerButton";

export function OrderDetailsChat({
  shouldShowChat,
  currentConversation,
  facebookId,
  customerName,
  isInactive,
}: UseOrderConversationReturn) {
  const {
    messages,
    sendMessage,
    isLoadingMessage,
    onLoadMoreMessage,
    messageAfterCursor,
  } = useChat();
  const [isChatOpen, setIsChatOpen] = useState(false);
  const user = getAuthUser();

  if (!shouldShowChat || !currentConversation) {
    if (isInactive) {
      return (
        <div className="fixed bottom-4 right-4 z-50 max-w-sm rounded-xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-900 shadow-lg">
          <p className="font-semibold">Inactive Facebook conversation</p>
          <p className="mt-1 text-xs">
            This order belongs to another Facebook Page. Live chat and replies are disabled.
          </p>
        </div>
      );
    }
    if (user && facebookId) {
      return <FacebookMessagerButton psid={facebookId} pageId={user?.facebookPage?.pageId} customerName={customerName || ''} />
    }
    return null;
  }

  return (
    <ChatFloatingWidget
      currentConversation={currentConversation}
      messages={messages ?? []}
      prevCursor={messageAfterCursor ?? ""}
      OnLoadMoreMessage={onLoadMoreMessage}
      OnNewMessage={sendMessage}
      isLoadingMessage={isLoadingMessage}
      open={isChatOpen}
      onOpenChange={setIsChatOpen}
      inactive={isInactive}
    />
  );
}
